import { z } from "zod";

import { SyncDuplicateProductsDtoSchema } from "../../../dtos/duplicate-products";

export const SyncDuplicateProductsRequestBodySchema = z.object({
  experienceId: z.string().uuid(),
  products: SyncDuplicateProductsDtoSchema.array(),
});

export type SyncDuplicateProductsRequestBodyType = z.infer<
  typeof SyncDuplicateProductsRequestBodySchema
>;

export const SyncDuplicateProductsResponseBodySchema = z.string();

export type SyncDuplicateProductsResponseBodyType = z.infer<
  typeof SyncDuplicateProductsResponseBodySchema
>;
